import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/fr-ca'

dayjs.extend(relativeTime)

export const isAfter = (timestamp1, timestamp2) => {
  if (!timestamp1) throw new Error('Missing required argument: timestamp1')
  if (!timestamp2) throw new Error('Missing required argument: timestamp2')

  return dayjs(timestamp2).isAfter(dayjs(timestamp1)) ? 1 : -1
}

export const fromNow = (timestamp) => {
  if (!timestamp) throw new Error('Missing required argument: timestamp')

  return dayjs(timestamp).fromNow()
}

export const humanize = (timestamp, format = 'D MMM YYYY, H:mm', locale) => {
  if (!timestamp) throw new Error('Missing required argument: timestamp')

  if (locale === 'fr-CA') return dayjs(timestamp).locale('fr-ca').format(format)

  return dayjs(timestamp).format(format)
}

export const dateFormatLocale = (timestamp, locale) => {
  // format date based on the locale
  if (!timestamp) throw new Error('Missing required argument: timestamp')

  // set the format globally
  const format = locale === 'fr-CA' ? 'D MMMM YYYY' : 'MMMM D, YYYY'
  if (locale === 'fr-CA') return dayjs(timestamp).locale('fr-ca').format(format)

  return dayjs(timestamp).format(format)
}

export const difference = (timestamp, unit = 'second') => {
  if (!timestamp) throw new Error('Missing required argument: timestamp')

  return dayjs().diff(timestamp, unit)
}

export const timeStampFormattedDate = (date) => {
  if (!date) return null

  return dayjs(date).format()
}

export const fromNowFormatLocale = (timestamp, locale) => {
  // format date based on the locale
  if (!timestamp) throw new Error('Missing required argument: timestamp')

  // set the format globally
  if (locale === 'fr-CA') return dayjs(timestamp).locale('fr-ca').fromNow()

  return dayjs(timestamp).fromNow()
}
